module.exports = __webpack_public_path__ + "static/media/Book.679158b5.jpg";